// Promotions: automatic discounts a store runs (no code to enter). The server
// does all the pricing — the catalogue already carries promotional prices, with
// the regular price as list_price — so these helpers only present them.

export const storeHasPromotions = (storeSettings) =>
  storeSettings?.tenant_features?.promotions === true;

// The price a product (or variant) sells for without any promotion — what a
// subscription is charged, since promotions apply to one-time orders only.
export const regularPrice = (entry) => {
  if (!entry) return 0;
  return typeof entry.list_price === 'number' ? entry.list_price : entry.price;
};

// A catalogue product with any promotion taken back off — for screens whose
// charges don't get promotions (subscriptions).
export const withoutPromotion = (product) => {
  if (!product || (typeof product.list_price !== 'number' && !product.promotion
      && !(product.variants || []).some((v) => typeof v.list_price === 'number'))) return product;
  const { promotion, list_price: _lp, ...rest } = product;
  return {
    ...rest,
    price: regularPrice(product),
    variants: (product.variants || []).map(({ list_price, ...v }) => ({ ...v, price: typeof list_price === 'number' ? list_price : v.price })),
  };
};

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

// "Ends today", "Ends tomorrow", or "Till 5 Nov" — `today` as YYYY-MM-DD.
export const promotionEndsText = (endDate, today) => {
  if (!endDate) return '';
  if (endDate === today) return 'Ends today';
  const [y, m, d] = endDate.split('-').map(Number);
  if (!y || !m || !d) return '';
  const tomorrow = new Date(`${today}T00:00:00Z`);
  tomorrow.setUTCDate(tomorrow.getUTCDate() + 1);
  if (endDate === tomorrow.toISOString().slice(0, 10)) return 'Ends tomorrow';
  return `Till ${d} ${MONTHS[m - 1]}`;
};

// Today's date in the store's timezone (India), matching the server's rule.
export const storeToday = (now = new Date()) =>
  new Date(now.getTime() + 330 * 60000).toISOString().slice(0, 10);
